import React, { useState } from 'react';
import { Collapse, Button, Card, CardContent } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ExpandLessIcon from '@material-ui/icons/ExpandLess'; // Upward arrow
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'; // Downward arrow
import PropTypes from 'prop-types';

const useStyles = makeStyles({
  button: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px',
    width: '100%',
    textAlign: 'left',
  },
  title: {
    color: '#3C75C7',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '16px',
    letterSpacing: '1.4px',
    textTransform: 'uppercase',
    padding: '8px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  icon: {
    marginLeft: 'auto',
  },
  content: {
    padding: '3px',
    marginTop: '4px',
    boxShadow: 'none',
  },
});

const CollapsibleBox = ({ title, children }) => {
  const [open, setOpen] = useState(false);
  const classes = useStyles();

  return (
    <div>
      <Button className={classes.button} onClick={() => setOpen(!open)}>
        <div>
          <span className={classes.title}>{title}</span>
        </div>
        {open ? (
          <ExpandLessIcon className={classes.icon} />
        ) : (
          <ExpandMoreIcon className={classes.icon} />
        )}
      </Button>
      <Collapse in={open}>
        <Card className={classes.content}>
          <CardContent>{children}</CardContent>
        </Card>
      </Collapse>
    </div>
  );
};
CollapsibleBox.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default CollapsibleBox;
